<template>
  <v-dialog v-model="dialog" persistent max-width="500">
    <template v-slot:activator="{ on: dialog1 }">
      <v-tooltip
        v-if="!$vuetify.breakpoint.xsOnly"
        bottom
        :color="$vuetify.theme.themes.light.tooltipColor"
      >
        <template v-slot:activator="{ on: tooltip, attrs }">
          <img
            v-bind="attrs"
            v-on="{ ...tooltip, ...dialog1 }"
            src="@/assets/icons/booking_Cancel.svg"
            class="ml-3"
            width="22px"
          />
        </template>
        <span>Cancel</span>
      </v-tooltip>
      <v-list-item @click.stop="dialog = !dialog" v-else>
        Cancel
      </v-list-item>
    </template>
    <v-card class="dialog-cls">
      <v-card-title class="dialog-title">Reason for Cancel</v-card-title>
      <v-divider></v-divider>
      <ValidationObserver ref="obs" v-slot="{ invalid, validated, passes }">
        <v-card-text>
          <VTextArea
            v-model="cancellationReason"
            filled
            placeholder="Enter you reason here..."
            :rules="{ required: true }"
            counter="500"
            maxlength="500"
          ></VTextArea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="disAgree">Cancel</v-btn>
          <v-btn
            :disabled="invalid || !validated"
            color="#344452"
            :dark="!invalid"
            @click="passes(agree)"
            >Submit</v-btn
          >
        </v-card-actions>
      </ValidationObserver>
    </v-card>
  </v-dialog>
</template>

<script>
import { BookingService } from "@/services";
import { ValidationObserver } from "vee-validate";
import { VTextArea } from "@/components/inputs";

export default {
  name: "RejectBooking",
  components: {
    ValidationObserver,
    VTextArea
  },
  data() {
    return {
      dialog: false,
      cancellationReason: null
    };
  },
  props: {
    bookingId: String,
    label: String
  },
  methods: {
    async agree() {
      this.dialog = false;
      const object = { reason: this.cancellationReason };
      const response = await BookingService.rejectBooking(
        this.bookingId,
        object
      );
      if (response) {
        this.$emit("refresh");
        this.$store.dispatch("user/setSnack", response.data.message);
        this.$store.dispatch("user/setType", "info");
      }
    },
    disAgree() {
      this.dialog = false;
    }
  }
};
</script>
